(function () {
  'use strict';

  const image1 = document.querySelector('#image_1');
  const image2 = document.querySelector('#image_2');
  const collectionItems = document.querySelector('#search_items');
  const mobile = window.matchMedia('(max-width: 767px)');
  if (collectionItems) {
    const items = collectionItems.querySelectorAll('.main-search__item');
    if (mobile.matches) {
      if (items[4]) {
        items[4].after(image1);
      } else {
        image1.style.display = 'none';
      }
      if (items[9]) {
        items[9].after(image2);
      } else {
        image2.style.display = 'none';
      }
    } else {
      if (items[5]) {
        items[5].after(image1);
      } else {
        image1.style.display = 'none';
      }
      if (items[9]) {
        items[9].after(image2);
      } else {
        image2.style.display = 'none';
      }
    }
  }

})();
